module.exports = __webpack_public_path__ + "static/benefits-img5-0348022fb6cbf392c71eda283c70d7fd.png";